import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-research-portal-access-denied',
  templateUrl: './research-portal-access-denied.component.html',
  styleUrls: ['./research-portal-access-denied.component.scss']
})
export class ResearchPortalAccessDeniedComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
